import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SharedLibraryService, sharedLibraryConfigProvider } from 'projects/petszel-shared/src/public-api';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { appConfig } from '../staff.config';
import { PetszelSharedModule } from 'projects/petszel-shared/src/public-api';
import { AuthInterceptor } from './service/auth-interceptor-staff.service';
import { NgbDateAdapter, NgbDateParserFormatter, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { setLicenseKey } from "survey-core";
import { CustomAdapter, CustomDateParserFormatter } from "./staff-date-picker-adapter";
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { authReducer } from './store/auth/auth.reducer';
import { AuthEffects } from './store/auth/auth.effects';
import { staffEnvironment } from '../environments/environment';

setLicenseKey(
    "YzNkNDg3NTQtOGQ0Ny00Y2U1LWFkNzgtZTgzOTgzMmY5NTZjOzE9MjAyNS0wMy0xNCwyPTIwMjUtMDMtMTQsND0yMDI1LTAzLTE0"
);
@NgModule({ declarations: [
        AppComponent,
        ConfirmationModalComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        RouterModule,
        CommonModule,
        PetszelSharedModule,
        LoggerModule.forRoot({
            level: NgxLoggerLevel.DEBUG, // set log level
            serverLogLevel: NgxLoggerLevel.ERROR, // set server log level
            disableConsoleLogging: false //enable/disable console logging
        }),
        NgbModule,
        StoreModule.forRoot({ auth: authReducer }),
        EffectsModule.forRoot([AuthEffects]),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: staffEnvironment.production
        })], providers: [
        {
            provide: 'appConfig',
            useValue: appConfig,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        sharedLibraryConfigProvider,
        SharedLibraryService,
        { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
